function confirmedUrl(value) {
  if (typeof value !== 'string' || !value.trim()) throw new Error('学习素材地址未确认，请核对原素材或重新上传')
  const url = value.trim()
  // Preserve actual upload locations; do not turn IDs, local files or temporary blobs into addresses.
  if (!/^https?:\/\/[^\s]+$/i.test(url) && !/^\/(?!\/)[^\s]+$/.test(url)) throw new Error('学习素材需使用已上传的真实地址，请重新上传')
  return url
}

export function materialFiles(urls) {
  if (urls == null) return []
  if (!Array.isArray(urls)) throw new Error('原学习素材格式未确认，请重新读取场景')
  return urls.map(value => { const url = confirmedUrl(value); return { url, name: url } })
}

export function materialUrls(files) {
  if (!Array.isArray(files)) throw new Error('学习素材列表未确认，请核对后保存')
  return files.map(file => confirmedUrl(typeof file === 'string' ? file : file && file.url))
}
